import { Component, OnInit, ViewChild } from '@angular/core';
import * as saveAs from 'file-saver';
import { SignaturePad } from 'angular2-signaturepad';
import { Observable, ReplaySubject, Subject, ignoreElements } from 'rxjs';
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { Config } from 'datatables.net';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-brouchers',
  templateUrl: './brouchers.component.html',
  styleUrls: ['./brouchers.component.css'],


})
export class BrouchersComponent implements OnInit {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  accessToken: string;
  broucherList: any = [];
  broucherPdfFile: any;
  dtOptions: Config = {
    pagingType: 'simple_numbers',
    language: {
      searchPlaceholder: 'Search here...',
    },
    destroy: true,
  };
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(
    private http: HttpClient, private router: Router,
  ) { }

  ngOnInit(): void {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Marketing Brouchers');
    },100)

    this.accessToken = sessionStorage.getItem('accessToken');
    this.getBrouchers()
  }





  getBrouchers() {

    let endPoint = '/common/brochures'

    this.http.get(environment.apiUrl + '/api/ap' + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.status == 200) {
        this.broucherList = response.data
        // $('#DataTables_Table_1').dataTable().fnDestroy();
        this.dtTrigger.next(null);
        // Swal.fire({ allowOutsideClick: false, title: "Info", text: response.message });

      } else {
        Swal.fire({ allowOutsideClick: false, title: "Error", text: response.message });
      }
    },
      (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: "Info",
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: "Proceed",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: "Error", text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      })
  }
  showBroucherFile(brochure: any) {
    // const encodedUrl = encodeURI(brochure.fileName);
    // this.broucherPdfFile = encodedUrl
    setTimeout(() => {
      //   this.broucherPdfFile = "https://testapi.groupbenefitz.aitestpro.com/app/server/en/terms-conditions-en.pdf";
      //   // this.broucherPdfFile = this.sanitizer.bypassSecurityTrustResourceUrl(encodedUrl);
      this.broucherPdfFile = encodeURI(brochure.fileName);


    }, 1000);


  }
  closePopup(id: any) {
    $(`#${id}`).hide();
    this.broucherPdfFile=''
  }
  downloadBroucher(brocuher: any) {
    this.http.get(brocuher.fileName, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = brocuher.name + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: "Error", text: error.error.error.message })
      }
    );

  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();


  }

}
